// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@acpaas-ui/aui-kit/dist/css/aui-kit.css
// module id = 885
// module chunks = 7